import type { CSSProperties } from 'react'
import type { IconName } from '@/shared/ui/icon'
import { cn } from '@/shared/lib/cn'
import { Icon } from '@/shared/ui/icon'
import s from './EmptyState.module.css'

type EmptyStateProps = {
  icon: IconName
  title: string
  description: string
  tint?: string
  className?: string
}

export function EmptyState({
  icon,
  title,
  description,
  tint = 'var(--st-in)',
  className,
}: EmptyStateProps) {
  return (
    <div className={cn(s.root, className)} style={{ '--tint': tint } as CSSProperties}>
      <div className={s.icon}>
        {/* 20px и обводка 2.4 — как у единственного образца в макете («Всё разобрано»,
            экран Задач). Дефолтные 2 у Icon дали бы заметно более тонкую галочку. */}
        <Icon name={icon} size={20} strokeWidth={2.4} />
      </div>
      <div className={s.title}>{title}</div>
      <div className={s.description}>{description}</div>
    </div>
  )
}
